// src/components/header/me-profile/HeaderContent.tsx
'use client';

import React, { type ComponentProps, type ElementType } from 'react';
import Avatar from '../../ui/avatar/Avatar';
import Link from 'next/link';
import { IconArrow, IconLoveBox } from '../../icons';
import ProfileDetail from '@/app/me/profile/(profile-detail)/ProfileDetail';
import { SideSheet } from '../../ui/sideSheet/SideSheet';
import { useAppSelector } from '@/store/hook';
import { DEFAULT_AVATAR } from '@/constants/image';

type AvatarProps = ComponentProps<typeof Avatar>;

type Props = {
  /** 語意化標籤（div/section/header...） */
  as?: ElementType;
  className?: string;
  spacing?: 'none' | 'sm' | 'md' | 'lg';

  /** 透傳給 Avatar（src/size/alt/href/border/borderColor/className） */
  avatar?: Partial<AvatarProps>;

  /** 其他可調參數 */
  displayName?: string;
  supportHref?: string;
  shopHref?: string;
};

const spacingMap: Record<NonNullable<Props['spacing']>, string> = {
  none: '',
  sm: 'py-2',
  md: 'py-5',
  lg: 'py-6',
};

const HeaderContent: React.FC<Props> = ({
  as: Tag = 'div',
  className,
  spacing = 'md',
  avatar,
  supportHref = '/me/coin-support',
  // shopHref = '/me/coin-shop',
}) => {
  const meInfo = useAppSelector((state) => state.auth.meInfo);
  const defaultAvatar: AvatarProps = {
    src: meInfo?.u_photo ?? DEFAULT_AVATAR,
    size: 48,
    alt: '頭像',
  };
  const avatarProps = { ...defaultAvatar, ...avatar } as AvatarProps;

  return (
    <Tag className={['', className].filter(Boolean).join(' ')}>
      <div
        className={['d-flex align-items-center justify-content-between', spacingMap[spacing]].join(
          ' '
        )}
      >
        <div className="d-flex align-items-center">
          <Avatar {...avatarProps} />

          <div className="ms-2">
            <div className="d-flex align-items-center mb-1">
              <h1 className="fs-6 fw-bold me-1">{meInfo?.name ?? '訪客'}</h1>
            </div>
            <SideSheet
              side="bottom"
              vh={75}
              editIcon
              editLink="/me/profile/edit"
              title="我的小檔案"
              titleHidden
              trigger={
                <span className="fs-sm-1 d-flex align-items-center">
                  <span className="me-1 fs-sm-2">我的小檔案</span>
                  <IconArrow width={20} />
                </span>
              }
            >
              <ProfileDetail />
            </SideSheet>
          </div>
        </div>

        <div className="d-flex align-items-center fs-sm-1">
          <Link href={supportHref} className="d-flex align-items-center">
            <IconLoveBox width={20} />
            <span>支持我</span>
          </Link>
          {/* <Link href={shopHref} className="d-flex align-items-center ms-4">
            <IconRecommend width={20} />
            <span>我推薦</span>
          </Link> */}
        </div>
      </div>
    </Tag>
  );
};

export default HeaderContent;
